import { Redirect } from 'react-router-dom';
import { Paths } from '../../utils/routerUrls';
import { ExaminerFunction } from './Assessment.types';
import { processIsNotAccessible } from '../../utils/assessmentSessionProcess';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import useSessionUser from '../../hooks/useSessionUser';

type AssessmentAccessGuardProps = {
  children: React.ReactNode;
  processTypeStringId: string;
};

const AssessmentAccessGuard: React.FC<AssessmentAccessGuardProps> = ({ children, processTypeStringId }) => {
  const { userAssessmentSessionInfo } = useSessionUser();

  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);
  const userFunction = userAssessmentSessionInfo.function;

  if (!assessmentSession) {
    return <Redirect to={Paths.dashboard} />;
  }

  if (userFunction === ExaminerFunction.CZE) {
    if (processIsNotAccessible(processTypeStringId)) {
      return <Redirect to={Paths.dashboard} />;
    }
  }

  return <>{children}</>;
};

export default AssessmentAccessGuard;
